/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Theme selector */
(function () {
    const THEME_STORAGE_KEY = 'streqo-theme';
    const themeButtons = document.querySelectorAll('.gh-theme-button');
    if (!themeButtons.length) return;

    const getStoredTheme = function () {
        return localStorage.getItem(THEME_STORAGE_KEY) || 'system';
    };

    const applyTheme = function (theme) {
        document.documentElement.setAttribute('data-theme', theme);
        themeButtons.forEach(function (button) {
            const isActive = button.getAttribute('data-theme-option') === theme;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
    };

    const setTheme = function (theme) {
        localStorage.setItem(THEME_STORAGE_KEY, theme);
        applyTheme(theme);
    };

    const initialTheme = getStoredTheme();
    applyTheme(initialTheme);

    themeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const nextTheme = button.getAttribute('data-theme-option') || 'system';
            setTheme(nextTheme);
        });
    });

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', function () {
        if (getStoredTheme() === 'system') {
            applyTheme('system');
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();